import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";

const MENU = [
	{ label: "Home", to: "/" },
	{ label: "Fixtures", to: "/fixtures" },
	{ label: "Predictions", to: "/predictions" },
	{ label: "Betting Tips", to: "/tips" },
	{ label: "Premium", to: "/premium" },
];

export default function MobileMenu({ headerSelector = "#header", breakpoint = 992 }) {
	const { pathname } = useLocation();
	const [open, setOpen] = useState(false);
	const [headerH, setHeaderH] = useState(64);

	useEffect(() => {
		const measure = () => {
			const h = document.querySelector(headerSelector)?.offsetHeight || 64;
			setHeaderH(h);
			if (window.innerWidth >= breakpoint && open) setOpen(false);
		};
		measure();
		window.addEventListener("resize", measure);
		window.addEventListener("scroll", measure, { passive: true });
		return () => {
			window.removeEventListener("resize", measure);
			window.removeEventListener("scroll", measure);
		};
	}, [headerSelector, breakpoint, open]);

	useEffect(() => {
		const prev = document.body.style.overflow;
		document.body.style.overflow = open ? "hidden" : prev || "";
		return () => { document.body.style.overflow = prev; };
	}, [open]);

	useEffect(() => {
		const onKey = (e) => e.key === "Escape" && setOpen(false);
		if (open) window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [open]);

	const isActive = (to) => pathname === to || (to !== "/" && pathname.startsWith(to));

	return (
		<>
			<button
				type="button"
				style={{ marginTop: 7 }}
				aria-label={open ? "Close menu" : "Open menu"}
				aria-expanded={open}
				onClick={() => setOpen((s) => !s)}
				className="mm-btn"
			>
				<span className={`mm-line ${open ? "x1" : ""}`} />
				<span className={`mm-line ${open ? "hide" : ""}`} />
				<span className={`mm-line ${open ? "x2" : ""}`} />
			</button>

			{open &&
				createPortal(
					<>
						<div className="mm-backdrop" onClick={() => setOpen(false)} style={{ top: headerH }} />
						<div className="mm-panel" style={{ top: headerH, height: `calc(100vh - ${headerH}px)` }}>
							<nav className="mm-nav" aria-label="Mobile">
								{MENU.map((it) => (
									<Link
										key={it.to}
										to={it.to}
										onClick={() => setOpen(false)}
										aria-current={isActive(it.to) ? "page" : undefined}
										className="mm-link"
									>
										{it.label}
									</Link>
								))}
							</nav>
						</div>
					</>,
					document.body
				)}

			<style>{`
        /* show ONLY on mobile */
        @media (min-width: ${breakpoint}px) { .mm-btn { display: none; } }

        .mm-btn {
          position: relative; width: 36px; height: 28px;
          background: transparent; border: 0; padding: 0; cursor: pointer; z-index: 1002;
          -webkit-tap-highlight-color: transparent;
        }
        .mm-line {
          position: absolute; left: 0; right: 0; height: 3px; background: #0f172a;
          border-radius: 2px; transition: transform .2s, opacity .2s, top .2s;
        }
        .mm-line:nth-child(1){ top: 0; }
        .mm-line:nth-child(2){ top: 12px; }
        .mm-line:nth-child(3){ top: 24px; }
        .mm-line.x1{ top: 12px; transform: rotate(45deg); }
        .mm-line.hide{ opacity: 0; }
        .mm-line.x2{ top: 12px; transform: rotate(-45deg); }

        .mm-backdrop {
          position: fixed; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,.45); z-index: 1000;
        }
        .mm-panel {
          position: fixed; left: 0; right: 0; background: rgba(255,255,255,.96);
          backdrop-filter: saturate(140%) blur(6px); z-index: 1001;
          display: flex; align-items: center; justify-content: center;
          transform: translateY(0); animation: mmSlide .22s ease-out both;
        }
        @keyframes mmSlide { from { transform: translateY(-6%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

        .mm-nav { display: flex; flex-direction: column; gap: 14px; align-items: center; }
        .mm-link { padding: 10px; font-size: 28px; font-weight: 600; color: #0f172a; text-decoration: none; }
        .mm-link[aria-current="page"] { color: #004aad; }
      `}</style>
		</>
	);
}
